import { render, staticRenderFns } from "./_RecordLogo.vue?vue&type=template&id=555942e2&scoped=true&"
import script from "./_RecordLogo.vue?vue&type=script&lang=js&"
export * from "./_RecordLogo.vue?vue&type=script&lang=js&"
import style0 from "./_RecordLogo.vue?vue&type=style&index=0&id=555942e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555942e2",
  null
  
)

export default component.exports